/* eslint-disable */
import React, { PureComponent } from 'react';
import CommonUtils from '../../utilities/common-utils';
import { Badge } from '@good/ui/core';

interface StatusTagProps {
  status:
    | 'PENDING'
    | 'ACCEPTED'
    | 'CANCELLED'
    | 'CONFIRMED'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'APPROVED'
    | 'READY_FOR_BILLING'
    | 'REQUIRES_APPROVAL'
    | 'BILLED'
    | 'BILLING_FAILED'
    | 'REJECTED'
    | 'ARCHIVED'
    | 'SEND_TO_FINANCE'
    | string;
  size?: 'small' | 'default' | 'large';
  textSize?: string;
  className?: string;
  textClassName?: string;
  rounded?: boolean;
  theme?: 'dark' | 'light';
  isFixedWidth?: boolean;
  width?: number;
}

export default class StatusTag extends PureComponent<StatusTagProps, any> {
  StatusColors = {
    PENDING: { color: 'gray', theme: 'dark' },
    ACCEPTED: { color: 'green', theme: 'dark' },
    CANCELLED: { color: 'red', theme: 'light' },
    CONFIRMED: { color: 'ocean', theme: 'dark' },
    INPROGRESS: { color: 'yellow', theme: 'dark' },
    COMPLETED: { color: 'lilac', theme: 'light' },
    APPROVED: { color: 'orange', theme: 'dark' },
    READY_FOR_BILLING: { color: 'dark', theme: 'dark' },
    BILLED: { color: 'lime', theme: 'dark' },
    BILLING_FAILED: { color: 'red', theme: 'dark' },
    REJECTED: { color: 'red', theme: 'dark' },
    CUSTOMER_CANCELLED: { color: 'red', theme: 'light' },
    CUSTOMER_CANCELLED_WITH_FEE: { color: 'red', theme: 'light' },
    CUSTOMER_CANCELLED_WITHOUT_FEE: { color: 'red', theme: 'light' },
    BUSINESS_CANCELLED: { color: 'red', theme: 'light' },
    REQUIRES_APPROVAL: { color: 'turquoise', theme: 'dark' },
    ARCHIVED: { color: 'red', theme: 'light' },
    SCHEDULED: { color: 'green', theme: 'dark' },
    SEND_TO_FINANCE: { color: 'ocean', theme: 'light' },
  };

  override render() {
    const { status } = this.props;

    const color = this.StatusColors[status] ? this.StatusColors[status].color : 'blue';
    const theme = this.StatusColors[status] ? this.StatusColors[status].theme : 'dark';

    return (
      <Badge variant={theme === 'dark' ? 'filled' : 'outline'} color={color}>
        {CommonUtils.formatStatusString(status)}
      </Badge>
    );
  }
}
